import axios from 'axios'
import {API} from 'src/feature/bite/domain'

interface CityListResponse {
  response: {
    cities: {
      id: string
      name: string
    }[]
  }
}

export default async function getCities(countryId: string) {
  const response = await axios.post<CityListResponse>(`${API}/City/GetCitiesbyCountry`, {
    countryId,
  })
  return response.data.response.cities
}
